// Actions
export const API_RESPONSE_SUCCESS = "API_RESPONSE_SUCCESS";
export const API_RESPONSE_ERROR = "API_RESPONSE_ERROR";
export const GET_CATEGORY_ORGANIZATION = "GET_CATEGORY_ORGANIZATION";
export const CREATE_CATEGORY_ORGANIZATION = "CREATE_CATEGORY_ORGANIZATION";
export const UPDATE_CATEGORY_ORGANIZATION = "UPDATE_CATEGORY_ORGANIZATION";
export const DELETE_CATEGORY_ORGANIZATION = "DELETE_CATEGORY_ORGANIZATION";
